import { render, staticRenderFns } from "./uploadNew.vue?vue&type=template&id=c42870c0&scoped=true"
import script from "./uploadNew.vue?vue&type=script&lang=ts"
export * from "./uploadNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42870c0",
  null
  
)

export default component.exports